module.exports = __webpack_public_path__ + "assets/retina_TranslateSegmentDetailed.0927e95efb003e3c0210b1523b46fe30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TranslateSegmentDetailed.png
// module id = 744
// module chunks = 0